import { SearchFilter, SearchFilterOptionRange } from "../../../redux-magic/sub-interfaces/search-types";

export const _o_possession_date: SearchFilter = {
	id: "possession_date",
	title: "Possession Date",
	level: 4,
	index: 14,
	presentation_type: "date_range_picker",
	multi: false,
	affects: [],
	affected_by: ["property_status"],
	priority: 4,
	is_advanced: false,
	included_in_search_bar: false,
	option_type: "range",
	possible_options: [
		{
			id: "possession_date",
			title: "Possession Date",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	active_options: [
		{
			id: "possession_date",
			title: "Possession Date",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	selected_options: [] as Array<SearchFilterOptionRange>,
	db_collection: "properties",
	db_field: "possession_date",
	is_visible: false,
	is_applied: false,
	is_accordion_open: true,
};
